<template>
  <span class="inline-flex items-center whitespace-nowrap rounded border px-2 py-0.5 text-xs font-medium leading-5" :class="toneClass"><slot /></span>
</template>

<script>
// Quiet chip in the sales-tools palette: grey on grey. Acknowledgement states
// are deliberately NOT colour coded; "role" is only a slightly darker grey,
// and red is reserved for a running event ("live").
export default {
  name: "SoChip",
  props: {
    tone: { type: String, default: "default" },
  },
  computed: {
    toneClass() {
      return {
        default: "bg-secondary-50 border-secondary-200 text-secondary-700",
        role: "bg-secondary-100 border-secondary-300 text-secondary-800",
        live: "bg-red-50 border-red-200 text-red-700",
        plain: "bg-white border-secondary-200 text-secondary-600",
        blue: "bg-blue-50 border-blue-200 text-securdia-blue",
      }[this.tone];
    },
  },
};
</script>
